export const es = {
  ADD_COLOR_STRING_KEY: 'Añadir color',
  ADD_TEXT_KEY: 'Añadir texto',
  ADD_TO_ORDER_KEY: 'Agregar a la orden',
  ADD_TO_CART: 'Añadir a la cesta',
  ADD_TEMPLATE: 'Añadir plantilla',
  ADJUST_SIZE_KEY: 'Ajustar tamaño',
  ADJUST_TRANSPARENCY_KEY: 'Ajustar la transparencia',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    'Al hacer clic en Hecho, acepta las condiciones generales y la declaración de privacidad de HP.',
  ALIGN_BOTTOM_KEY: 'Alinear abajo',
  ALIGN_CENTER_KEY: 'Alinear al centro',
  ALIGN_KEY: 'alinear',
  ALIGN_LEFT_KEY: 'inicio',
  ALIGN_MIDDLE_KEY: 'alinear el medio',
  ALIGN_RIGHT_KEY: 'fin',
  ALIGN_TOP_KEY: 'Alinear arriba',
  ALL_TAB_TITLE_KEY: 'Todo',
  ALMOST_DONE_TITLE_KEY: 'Casi ha terminado.',
  AND_KEY: 'y',
  APPLY_KEY: 'Aplicar',
  AREA_CODE: 'Codigo de AREA',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Examine los contenidos y seleccione las imágenes del diseño o cargue las suyas propias',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Previsualice el diseño o ajuste los detalles.',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Personalice el diseño y añada más elementos al proyecto',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'Cuando el diseño esté listo, haga clic en SIGUIENTE para hacer una revisión final y pasar el pedido.',
  BACK_KEY: 'Atrás',
  BACKGROUND_KEY: 'Fondo',
  BACKGROUND_UPPER_CASE_KEY: 'FONDO',
  BACKGROUND_CONTRAST_KEY: 'Contraste del fondo',
  BLANK_INSPIRATION_CATEGORY_KEY:
    'No se han encontrado inspiraciones en esta categoría.',
  BRING_TO_FRONT_KEY: 'Traer al frente',
  CANCEL_TEXT_KEY: ' Cancelar ',
  CENTIMETERS_KEY: 'centímetros',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: 'Cambia la configuración de tu proyecto',
  CHECKBOX_CONTENT1: 'Quiero recibir el boletín de Pattern Design ©',
  CHECKBOX_CONTENT2:
    'Autorizo a HP a crear una cuenta en los servicios de Pattern Design © en mi nombre',
  CHOOSE_FROM_COMPUTER_KEY: 'Escójala en el ordenador',
  CHOOSE_RIP_OPTIONS: 'Seleccione uno de estos RIP compatibles de terceros',
  CHOOSE_FILE_KEY: 'Seleccione archivo',
  CITY: 'Ciudad',
  CLEAR_ALL_KEY: 'Borrar todo',
  CLEAR_COLOR_KEY: 'Borrar color',
  CLOSE_WINDOW_KEY: 'Cerrar ventana',
  CLEAR_ALL_OBJECTS: 'Borrar todos los objetos',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Se eliminarán todos los objetos del fondo.',
  CLEAR_DESIGN_KEY: 'Borrar diseño',
  COLOR_KEY: 'Color',
  CONTINUE_KEY: 'Continuar...',
  COMPANY: 'Empresa',
  CONGRATULATIONS_KEY: 'Enhorabuena',
  CONFIRM_PASSWORD: 'Confirmar contraseña',
  CONFIRM_PATTERN_ACCOUNT_KEY:
    '¿Todavía no tiene una cuenta de Pattern Design?',
  CONFIRM_VECTEEZY_ACCOUNT_KEY: '¿Aún no tienes una cuenta en Vecteezy?',
  COUNTRY: 'País',
  CREATE_ACCOUNT: 'Crear una cuenta',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Personalizado',
  CUSTOM_PRICE_SIGN_IN_KEY:
    'Regístrese en el siguiente paso para ver los precios personalizados.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Crear nuevo',
  DESIGN_KEY: 'Diseño',
  DELETE_KEY: 'Eliminar',
  DOCUMENT_COLORS: 'Colores del documento',
  DONE: '¡Hecho!',
  DONE_KEY: 'Hecho',
  DONT_SHOW_ALERT_KEY: 'No volver a mostrar',
  DOWNLOAD_COLUMN_HEADER_KEY: 'Descargar',
  DOWNLOAD_APP_TITLE_KEY: 'Puede descargar la aplicación aquí:',
  DOWNLOAD_LINK_KEY: 'Descargue aquí HP Click de manera gratuita',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Descargue HP SmartStream',
  DOWNLOAD_INSTR_KEY:
    'Asegúrese de que ha instalado HP Click antes de continuar',
  DOWNLOAD_SMARTSTREAM_KEY: 'Descargue HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Importación de Dropbox',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'El tamaño de la imagen deberá ser inferior a 1 GB. Aceptamos formato pdf, png, jpg, svg y tiff.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Busqueda de Dreamstime',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Imágenes de Dreamstime',
  DUPLICATE_KEY: 'Duplicar',
  EACH_ITEM_PRICE_KEY:
    'Su diseño incluye contenidos de uno de nuestros proveedores de contenidos premium. Más abajo se resume el precio por artículo de cada elemento.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Editar diseño',
  EDIT_LOWERCASE_KEY: 'editar',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'Lamentablemente se ha producido un error. Inténtelo de nuevo más tarde.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Vaya, se ha producido un error al abrir el archivo PDF cargado.',
  EMAIL_KEY: 'Email',
  EMAIL_ADDRESS_KEY: 'Dirección de email:',
  EMAIL_CHECKBOX_MESSAGE:
    'Soy consciente de que esta persona sabe que recibirá emails de HP de mi parte o de parte del proveedor de servicios.',
  EXTRA_INFO_KEY: 'Información adicional',
  EMAIL_NOTIFICATION:
    'Recibirá un email en breve. Podría tardar hasta 15 minutos.',
  EMAIL_DIALOG_MESSAGE:
    'Escriba la dirección de email de la persona con la que desee compartir el diseño.',
  ENTER_KEY: 'Entrar',
  EXISTING_FOLDER_KEY: 'Carpeta existente',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Asegúrese de que todos los elementos seleccionados están correctos antes de proceder con el pago',
  FINAL_CHECK_TITLE_KEY: 'Revision final',
  FINISH_KEY: 'Finalizar',
  FINISH_LATER_KEY: 'Terminar después',
  FIRSTNAME: 'Nombre de pila',
  FISCAL_NUM: 'Número fiscal',
  FLIP_KEY: 'Rotar',
  FOR_KEY: 'para',
  FORGOT_PASSWORD_KEY: '¿Ha olvidado la contraseña?',
  FOTOLIA_KEYWORDS_KEY: 'Palabras clave:',
  FOLDER_NAME: 'Nombre de la carpeta',
  FOLDER_NAME_KEY: 'Nombre de la carpeta:',
  FOLDER_ALREADY_EXIST_KEY: 'Este nombre de carpeta ya existe.',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    'Ha finalizado el diseño de su cartel gratuito',
  FREE_VECTOR_GRAPHICS_KEY: 'gráficos vectoriales gratis',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Vale, entendí',
  GROUP_ALL_KEY: 'Agrupar todo',
  GROUP_SCALE: 'Agrupar escala',
  GIFT_WRAPS_KEY: 'Papel de regalo',
  GIVE_PROJECT_NAME_KEY: 'Dele un nombre a su proyecto',
  HEIGHT_KEY: 'Altura',
  TOUR_DESCRIPTION_TEXT:
    'Hagamos un recorrido por el proceso de diseño. Recuerde que podrá volver a abrir el tour cuando desee haciendo clic en el icono de ayuda.',
  HELP_KEY: 'Ayuda',
  HELPER_TITLE_KEY_1:
    'Cree diseños de póster desde una página en blanco o desde millones de imágenes y texto. Sube tu propio contenido desde unidades locales, Dropbox o redes sociales',
  HELPER_TITLE_KEY_3: 'Vea todos sus trabajos de diseño en un solo lugar.',
  HELPER_TITLE_KEY_4:
    'Haga clic en Siguiente para obtener una vista previa y terminar su diseño final',
  HERE_KEY: 'aquí',
  HELP_IMPROVE_KEY:
    'Mejore la productividad y eficacia del operador y amplíe la producción de color.',
  HIGH_QUALITY_KEY: 'Patrones vectoriales',
  IMAGES_TITLE_KEY: 'Imágenes',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'Importando',
  INCHES_COLUMN_HEADER_KEY: 'Pulgadas',
  INCHES_KEY: ' pulgadas',
  INCHES_UNIT_STRING_KEY: 'pulg.',
  INVALID_EMAIL_ADDRESS_KEY: 'Dirección de email no válida',
  INVALID_INFO_KEY: 'Introduzca los detalles.',
  INVALID_NAME_KEY: 'Nombre no válido',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'El archivo que ha seleccionado es demasiado grande. El tamaño máx. de archivo es de 500mb.',
  INSUFFICIENT_CREDITS_KEY: 'Crédito insuficiente',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiración',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Vaya, el formato del archivo no es válido. Solo podemos procesar pdf, jpg, png, svg y tif.',
  LANDSCAPE_KEY: 'Paisaje',
  LANGUAGE_LABLE_KEY: 'Idioma',
  LASTNAME: 'Apellido',
  LEARN_MORE: 'Saber más',
  LEARN_THE_BASICS_KEY: 'Aprenda lo más básico',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Al utilizar esta página web, se compromete a estar obligado por estos',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Esta página web cumple',
  LEGAL_FOOTER_MESSAGE3_KEY: 'y el',
  LENGTH_STRING_IN_INCHES_KEY: 'en',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'cambiar',
  LINK_READER_APP_KEY: 'Aplicación LinkReader',
  LINK_READER_APP_DESCRIPTION_KEY:
    'Para visualizar el contenido que está añadiendo, descargue la aplicación LinkReader.',
  LOADING_KEY: 'Cargando...',
  LOADING_TEMPLATE_KEY: 'Cargando plantilla',
  LOGIN_NOW: 'Inicia sesión ahora',
  LOCK_KEY: 'Bloquear',
  LOGIN_KEY: 'Iniciar sesión',
  LOGIN_PATTERN_DESIGN_KEY: 'Iniciar sesión en Pattern design',
  LOGIN_SUBTITLE_KEY:
    'Inicie sesión para ver los precios personalizados y la información de pago',
  LOGIN_VECTEEZY_KEY: 'Iniciar sesión en Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Inicie sesión en Dreamstime ',
  LOGOUT_KEY: 'Cerrar sesión',
  MATERIAL_TITLE_KEY: 'MATERIAL',
  MATERIAL_STRING_KEY: 'Material',
  MEASUREMENT_KEY: 'Medida',
  METRIC_KEY: 'Métrico',
  MOBILE: 'Móvil',
  MODEL_TITLE_KEY: 'Modelo',
  MORE_INFO_TEXT_KEY: 'Más información',
  MY_GIFTWRAPS_KEY: 'Mis papel de regalo',
  MY_WORK_KEY: 'Mi trabajo',
  MY_WORK_SAVE_KEY: 'Su diseño ha sido guardado en su espacio Mi trabajo',
  NAME_KEY: 'Nombre:',
  NEXT_BUTTON_TITLE_KEY: 'Siguiente',
  NEW_FOLDER_KEY: 'Carpeta nueva',
  NO_SHADOW_KEY: 'Sin sombra',
  OBJECT_QUANTITY_KEY: 'Cantidad',
  OBJECTS_UPPER_CASE_KEY: 'OBJETOS',
  OK_KEY: 'Aceptar',
  ORDER_SAMPLE_KEY: 'Pedir muestra',
  ORDER_SAMPLE: 'Pedir una muestra',
  ORDER_SAMPLE_INFOLABEL_1:
    'Seleccione la pieza de la imagen que desee pedir a modo de muestra',
  ORDER_SAMPLE_INFOLABEL_2:
    'Recibirá un email con una vista en primer plano del proyecto a tamaño real',
  ORDER_SAMPLE_INFOLABEL_3:
    'Le servirá para valorar la calidad y la resolución.',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Pedir muestra ahora',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Reciba un email que incluya una vista en primer plano del proyecto a tamaño real para que pueda evaluar su calidad y resolución.',
  ORIENTATION_KEY: 'Orientación',
  OTHER_PRINTING_OPTIONS: 'Otras opciones de impresión',
  PASSWORD_KEY: 'Contraseña',
  PATTERN_COLOR_KEY: 'Color de patrón',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'para',
  PDF_GENERATION_ERROR_MESSAGE_KEY:
    'Error al general el pdf. Inténtelo de nuevo.',
  PHOTOS_KEY: 'FOTOGRAFÍAS',
  PHOTO: 'fotografía',
  PHONE: 'Teléfono',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Poseo el copyright de esta imagen y acepto',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'El tamaño de la imagen deberá ser inferior a 500 MB. Aceptamos formato png, jpg, tiff, svg y pdf',
  PIXEL_COLUMN_HEADER_KEY: 'Pixel',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Introducir texto aquí...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'Por ejemplo, algunas cosas importantes que necesite comunicar a la imprenta',
  PLACEHOLDER_INCHES_STRING_KEY: 'en',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'Mi cartel',
  PORTRAIT_KEY: 'Retrato',
  POSITION: 'Posición',
  PREMIUM_IMAGES_TITLE_KEY: 'Imágenes premium:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Guardar el proyecto',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'El proyecto ha sufrido cambios que deben guardarse antes de continuar.',
  PRICE_COLUMN_HEADER_KEY: 'Precio',
  PRINTER_SERIAL_NUMBER_KEY: 'Número de serie de impresoras*',
  PRINTING_ENABLE_DETAILS_KEY:
    'Con el fin de posibilitar la impresión, necesitamos más información',
  PRINTER_MODELS_KEY: 'Modelos de impresoras*',
  PROCESSING_KEY: 'Procesando...',
  PROCESSING_ALERT_TXT: 'No cierre la ventana mientras se procesa el diseño.',
  PROCESSING_ALERT_TXT2:
    'Una vez finalizado el procesamiento, HP Click se abrirá automáticamente y comenzará a descargar su archivo',
  PROCESSING_DONE: 'Casi ha terminado',
  PROCESSING_FILE_TXT: 'Su archivo se está procesando.',
  PROCESSING_TIME_TXT:
    'Esto podría tardar un tiempo ya que estamos conformando su creación para garantizar la mejor calidad de imagen',
  PROCESSING_ALERT_TXT3: 'El PDF se descargará automáticamente en su ordenador',
  PROCESSING_ALERT_TXT4:
    'Recuerde que puede configurar su conexión JDF en los ajustes para automatizar',
  PREMIUM_CONTENT_KEY: 'Contenidos Premium',
  PREVIEW_KEY: 'Vista previa',
  PROFESSIONAL_USE_TITLE_KEY: 'uso profesional.',
  PROJECT_NAME_KEY: 'Nombre del proyecto',
  PROJECT_NAME: 'Nombre del proyecto:',
  PROJECT_ALREADY_EXIST_KEY: 'Este nombre de proyecto ya existe',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Este nombre de proyecto ya existe',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Este nombre de carpeta ya existe.',
  PIXELATION_WARNING_KEY: 'Advertencia de pixelado',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'Debido a la resolución de su foto cargada, su piel puede estar distorsionada o distorsionada. Para asegurarse de que no haya borrosidad, cargue una imagen de buena calidad y evite que la imagen se estire. Si está satisfecho con la vista previa y desea continuar, continúe enviando.',
  REGISTER_CONTACTINFO: 'Información del contacto',
  REGISTER_INFO: 'Registrar informacion',
  REGISTER_PATTERNSUB1: 'Como cliente de valor de HP,',
  REQUIRED_FIELDS_KEY: 'Campos obligatorios',
  REQUIRED_FIELDS_TEXT_KEY: 'Campos obligatorios',
  REQUIRED_STRING_KEY: 'OBLIGATORIO',
  RECOLOR_KEY: 'Color',
  RADICALLY_SIMPLE_KEY: 'Software de impresión extremadamente sencillo',
  RIPSELECTION_HEAD:
    'Es la primera vez, seleccione el software de impresión compatible que prefiera',
  RIPSELECTION_DESC:
    'Su selección será la ruta de opción de impresión predeterminada en las impresiones futuras. Podrá realizar cambios posteriormente en los ajustes',
  REGISTER_COMPANYINFO: 'Información de la empresa',
  REGISTER_KEY: 'Registro',
  REGISTER_NOW: 'Regístrese ahora',
  REOLOR_KEY: 'Color',
  REQUEST_SAMPLE_KEY: 'Solicitar una muestra',
  RESIZE_KEY: 'Cambiar tamaño',
  RESIZE_ARBITRARILY_KEY: 'Cambiar tamaño de manera arbitraria',
  RESIZE_PROPORTIONALLY_KEY: 'Cambiar tamaño de manera proporcional',
  REVIEW_AND_SUBMIT_KEY: 'Revisar y enviar',
  REQUEST_FOR_QUOTATION: 'Solicitar presupuesto',
  RIGHT_LOGO_TEXT_KEY: 'por',
  ROTATE_KEY: 'Girar',
  ROTATE_LEFT_KEY: 'Girar 90° a la izquierda',
  ROTATE_RIGHT_KEY: 'Girar 90° a la derecha',
  ROTATION_KEY: 'Rotación',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Filas y columnas',
  ROYALTY_FREE_KEY: 'sin fisuras,',
  ROYALTY_KEY: 'realeza',
  SALUTATION: 'Saludo',
  SAVE_KEY: 'Guardar',
  SAVING_KEY: 'Guardando...',
  SAVE_INSPIRATION: 'Guardar inspiración',
  SAVE_TEMPLATE: 'Guardar plantilla',
  SAVE_DIALOG_TITLE: 'Guardar el proyecto',
  SAVE_PROJECT_NAME_KEY: 'Guardar el proyecto primero',
  SAVEDIALOG_MESSAGE:
    'Inicie sesión para guardar el proyecto. Si no dispone de cuenta, le ayudaremos a crear una. No se perderá su avance.',
  SEAMLESS_KEY: 'de gran calidad',
  SCALE_INFO_STRING_KEY: 'Escale la imagen para que se ajuste en su diseño.',
  SCALE_KEY: 'Escalar',
  SCALE_ALL_KEY: 'Escalar todo',
  SCALE_TO_FILL_KEY: 'Escalar para rellenar',
  SEARCH_BUTTON_TITLE_KEY: 'Buscar',
  SELECT_CUSTOM_SIZE_KEY: 'Seleccionar tamaño personalizado',
  SELECT_CUSTOM_KEY: 'Personalizado',
  SEARCH_TITLE: 'Buscar',
  SELECTED_IMAGE_KEY: 'Imagen seleccionada:',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Seleccione el tamaño de papel de regalo',
  SELECT_COUNTRY: 'Seleccionar país',
  SELECT_SALUTATION: '---Seleccionar---',
  SELECT_POSTER_SIZE_KEY: 'Seleccione el tamaño del cartel',
  SELECT_PRINTING_OPTION_KEY: 'Seleccione la opción de impresión que prefiera',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Envíeme instrucciones de instalación',
  SEND_TO_BACK_KEY: 'Mandar atrás',
  SEND_KEY: 'Enviar',
  SEND_TO_PRINT_TITLE_KEY: 'Enviar a imprimir',
  SET_SIZE_KEY: 'Establecer tamaño',
  SETTINGS_KEY: 'Ajustes',
  SETTINGS_UPPERCASE_KEY: 'AJUSTES',
  SHARE_KEY: 'Compartir',
  SIGNED_IN_AS_KEY: 'Sesión iniciada de',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Regístrese para ver los precios personalizados y la información de pago',
  SIGN_UP_NOW_KEY: 'Regístrate ahora',
  SKIP_KEY: 'Saltar',
  SOLID_COLORS_KEY: 'Colores sólidos',
  SQFT_UNIT_STRING_KEY: 'pies cuadrados',
  SQM_UNIT_STRING_KEY: 'm²',
  START_TOUR_KEY: 'Empezar tour',
  STATUS_MSG: 'Su archivo se ha enviado a imprimir',
  SUBMIT_BUTTON_KEY: 'Enviar',
  SHARE_LINK_LABEL: 'Seleccione el tipo de enlace que desee compartir',
  SHARE_EDIT_LINK: 'Editar enlace',
  SHARE_VIEW_LINK: 'Ver enlace',
  SHARE_YOUR_CREATION: 'Comparta su creación',
  STREET_ADD: 'Dirección',
  TARGET_VIEWING_HINT:
    '*No se puede modificar la distancia de visualización del objetivo desde los ajustes.',
  TERMS1_KEY: 'condiciones',
  TERMS2_KEY: 'Declaración de privacidad de HP',
  TERMS3_KEY: 'Aviso relativo a los derechos sobre datos personales',
  TERMS_OF_USE_KEY: 'Condiciones de uso',
  TERMS_OF_USE: 'Condiciones de uso.',
  TEXT_SHADOW_COLOR_KEY: 'Color sombra del texto',
  TEXT_ANCHOR_MIDDLE: 'medio',
  TEXT_UPPERCASE_KEY: 'TEXTO',
  TILE_KEY: 'Mosaico',
  TOTAL_KEY: 'TOTAL',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparencia',
  TEMPLATES_KEY: 'plantillas',
  TEMPLATES_UPPER_CASE_KEY: 'PLANTILLAS',
  THANK_YOU_KEY: 'Gracias',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Desbloquear',
  UNGROUP_KEY: 'Desagrupar',
  UPDATE_TEXT_KEY: 'Actualizar',
  UPLOAD_KEY: 'Cargar',
  UPLOAD_LOGO_KEY: 'Subir logo',
  UPLOAD_IMAGE_KEY: 'Cargue su propia imagen',
  UPLOAD_UPPERCASE_KEY: 'SUBIR',
  USER_NAME: 'Nombre de usuario',
  USER_TYPE_TITLE_KEY: '¿Qué tipo de usuario es usted?*',
  UNTILE_KEY: 'Deshacer mosaico',
  UNSPLASH_SEARCH_TITLE: 'Búsqueda de Unsplash',
  VALIDITY_KEY: 'Validez',
  VANILLA_LOGIN_DIALOG_KEY:
    'Apúntese de forma gratuita para guardar e imprimir su diseño y ver los trabajos guardados',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'Aquí tiene la previsualización de su diseño, compruebe que sea definitiva antes de continuar o seleccione editar para realizar cambios.',
  VAT_KEY: 'IVA',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'y sin canon',
  VIEW_FOTOLIA_KEY: 'Ver en Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Ver los detalles del diseño',
  VIEW_DESIGNER_PROFILE_KEY: 'Ver el perfil del diseñador',
  VIEW_PRICE_KEY: 'Ver precio',
  VECTEEZY_SEARCH_TITLE: 'Búsqueda de Vecteezy',
  WALL_POSTER_KEY: 'Carteles',
  WALL_SIZE_TEXT_KEY: 'Tamaño de la pared',
  WARNING_KEY: 'Advertencia',
  WEBSITE: 'Sitio web',
  WIDTH_KEY: 'Anchura',
  YOU_CAN_ALWAYS_ACCESS: 'Podrá acceder en todo momento a sus diseños en ',
  YOUR_NAME_KEY: 'Su nombre',
  YOUR_SELECTION_WILL_KEY:
    'Su selección será la ruta de impresión predeterminada en las impresiones futuras.',
  YOUR_PROJECT_KEY: 'Su proyecto:',
  PROJECT_NAME_ERROR_TEXT: 'Ponga un nombre a su proyecto.',
  PROJECT_FOLDER_ERROR_TEXT: 'Ponga un nombre a la carpeta de su proyecto.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Ajustes de advertencia de pixelado',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Distancia mínima de visualización',
  MINIMUM_ZOOM_WARNING:
    'No puede reducirse más la escala de este fondo, dado que ya se ha alcanzado la altura y anchura mínima necesarias para cubrir la pared.',
  BACKGROUND_UPLOAD_KEY: 'fondo',
  OBJECT_UPLOAD_KEY: 'objeto',
  PHOTO_UPLOAD_KEY: 'fotografía',
  NO_DREAMSTIME_ERROR_MESSAGE: 'No dreamstime contenido encontrado',
  NO_ELEMENT_ERROR_MESSAGE: 'No se han encontrado elementos.',
  NO_MORE_IMAGES_FOUND_KEY: 'No se encontraron más imágenes',
  NO_PATTERN_ERROR_MESSAGE: 'No se han encontrado patrones.',
  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  ALREDY_HAVE_AN_ACCOUNT: 'Ya tengo un {0} ¿cuenta?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Cambiar a {0}',
  DOWNLOADS_KEY: '{0} descargas',
  HEX_COLOR_KEY: 'Color hexagonal {0}',
  NEAR_KEY: 'Cerca',
  FAR_KEY: 'Lejos',
  CLOSE_UP_KEY: 'De cerca',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'Las imágenes que intenta utilizar son más pequeñas o más grandes que el área de diseño que está utilizando.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'Para obtener mejores resultados utiliza una imagen de resolución 999',
  MESSAGE_KEY: 'Mensaje:',
  VIEWS_KEY: '{0} puntos de vista',
  COST_DESCRIPTION_MESSAGE_KEY:
    'Este es el resumen de los costes relacionados con los contenidos premium incluidos en su diseño. {0} Al seleccionar finalizar, acepta que los proveedores de contenidos le cobren los costes siguientes.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} es su opción de impresión por defecto,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' revivirás $ 100 en imágenes de alta resolución {0} para ayudar con todas sus necesidades creativas!',
  REGISTER_PATTERNSUB3:
    'Regístrese hoy y en el transcurso de los próximos 30 días, descargue archivos creativos de nuestra base de contenido de 25 millones de fotos y vea cómo {0} Puede ayudarte a satisfacer tus necesidades creativas.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'Ha escalado la imagen impresa hasta un punto que podría aparecer pixelada cuando la visualice a {0} {1} * (resolución impresa actual de {2}ppi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'La distancia de visualización recomendada sería de {0} {1}. Si esto no fuera adecuado, disminuya la escala de la imagen o el tamaño de la pared.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'El tamaño mínimo de imagen recomendado debería ser de {0} x {1} píxeles.',
  UPLOAD_STATUS: '{0}% de {1}MB',
  REGISTER_TO: 'Registrarse para {0}',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MINIMUM_DIMENSIONS_KEY: 'Las dimensiones mínimas son {0} (an.) x {1} (al.).',
  MINIMUM_HEIGHT_KEY: 'La altura mínima es de {0}.',
  MINIMUM_WIDTH_KEY: 'La anchura mínima es de {0}.',
  MAXIMUM_DIMENSIONS_KEY:
    'Las dimensiones máximas son de {0} (an.) x {1} (al.).',
  MAXIMUM_WIDTH_KEY: 'La anchura máxima es de {0}.',
  MAXIMUM_HEIGHT_KEY: 'La altura máxima es de {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY:
    'Introduzca dimensiones numéricas por encima de cero.',
  PROCESSING_FAILED: 'Error de procesamiento, inténtelo de nuevo más tarde',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT: 'No se admiten PDF de varias páginas.',
  OF_KEY: 'de',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'Lo sentimos, los archivos PDF encriptados no son compatibles.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Importando archivo {0} de {1}',
  RECOLORING_KEY: 'Repigmentando...',
  TEXT_COLOR_KEY: 'Color del texto',
  SOLID_COLOR_KEY: 'Color sólido',
  AUTHENTICATE_DIALOG_TITLE:
    'Esta fuente de contenidos está protegida mediante contraseña',
  AUTHENTICATE_FAILED_MESSAGE: 'Error de autenticación.',
  DROPBOX_IMPORT_ERROR_HEADER:
    'Se ha producido un error al importar algún archivo',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Tamaño de página ¡Advertencia!',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Esta plantilla de inspiración viene con un tamaño predeterminado de {0} X {1} {2}. El tamaño de su página se cambiará automáticamente para adaptarse a esta plantilla.',
  MODIFY_SIZE_WARNING:
    'Si desea cambiar el tamaño de este diseño, puede hacerlo en la pestaña "Configuración". Los elementos de diseño pueden requerir edición para ajustarse a las dimensiones deseadas.',
  RANDOMIZE_KEY: 'Aleatorizar',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Provecto',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Selecciona tu portátil',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'Nombre',
  LAST_NAME_KEY: 'Apellidos',
  PHONE_NUMBER_KEY: 'N.º de teléfono',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'N.º de teléfono no válido',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'Acepto los términos y condiciones',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'Acepto que mi información personal se comparta con HP para que contacten conmigo en futuras campañas de HP.*',
  SERVICE_PROVIDER_CONDITION:
    'Acepto que los datos que he proporcionado puedan ser compartidos con proveedores de servicios a efectos de los procesos de impresión y entrega.*',
  ORDER_DESIGN: 'Pedido del diseño',
  SUBMIT_YOUR_DESIGN: 'Envía tu diseño',
  SUBMISSION_DESIGN_ORDER: 'Envío del pedido de diseño',
  ENTER_REQUIRED_FIELDS_KEY: 'Introduce los campos requeridos',
  ADDRESS_KEY: 'Dirección',
  INVALID_ADDRESS_KEY: 'Dirección no válida',
  CITY_KEY: 'Ciudad',
  INVALID_CITY_KEY: 'Ciudad no válida',
  COUNTRY_KEY: 'País',
  STATE_KEY: 'Estado',
  ZIP_KEY: 'Código postal',
  INVALID_ZIP_KEY: 'Código postal no válido',
  ORDER_NUMBER: 'Número de pedido',
  YOUR_DETAILS_KEY: 'Tus detalles',
  APPLY_DESIGN_COMPETITION: 'Participa en el concurso de diseño',
  NOTICE_KEY: 'darse cuenta:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'Para tener una máscara de PC perfectamente adaptada a la suya, debe seleccionar el modelo exacto correspondiente a la compra, como se ve en la factura.',
  RESTART_PROJECT_ALERT_TITLE: '¿Reiniciar un proyecto?',
  DISCARD_ALERT_MESSAGE: 'El proyecto actual se descartará',
  RESTART: 'Reiniciar',
  MATERIAL_CHOICE_APPLIED: 'Elección del material aplicado.',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'certificado de',
  AUTHENTICITY_STRING: 'autenticidad',
  PLEASE_WAIT: 'Un momento',
  PROTECTING_YOUR_DATA: 'protegiendo tus datos...',
  SEARCH_YOUR_LAPTOP_KEY: 'Busca tu laptop', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    '¡Uy! No pudimos encontrar ninguna computadora portátil para su búsqueda.', // Google translated
  SERIAL_NUMBER_KEY: 'Número de serie',
  LOCKED_PROJECT: 'Proyecto bloqueado',
  LOCKED_MESSAGE:
    'Este proyecto se ha pedido y no puede modificarse. Solo puedes visualizar el proyecto.',
  EXPIRED_PROJECT: 'Proyecto vencido',
  EXPIRED_MESSAGE: 'Este proyecto ha vencido.',
  DELETED_PROJECT: 'Proyecto eliminado',
  DELETED_MESSAGE: 'Este proyecto se ha eliminado.',
  CHOOSE_GROUP_TYPE: 'Elegir tipo {0}',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Introduzca números por encima de cero.',
  SIZE_KEY: 'Tamaño',
  DISTANCE_FROM_KEY: 'Distancia desde',
  MYROOM_UPPERCASE_KEY: 'MI HABITACION',
  FURNITURE_KEY: 'Muebles',
  FIXTURES_KEY: 'Elementos fijos',
  ADD_A_WALL_KEY: 'Añadir una pared',
  SELECT_A_WALL_KEY: 'Seleccionar pared',
  LEFT_KEY: 'Izquierda',
  RIGHT_KEY: 'Derecha',
  DELETE_WALL_KEY: 'Eliminar pared',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Elija el tipo de lienzo',
  MAXIMUM_WALL_SIZE_KEY: 'El tamaño máximo de la pared {0}cuadrados{1}',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY:
    'La altura del lienzo supera la de la pared.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY:
    'La anchura del lienzo supera la de la pared.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'El número máximo de columnas para la anchura actual es de {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'El número máximo de filas para la altura actual es de {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'La anchura del lienzo es inferior a la de la pared.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'La pared debe tener una anchura mínima de {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'La pared debe tener una altura mínima de {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'La altura del lienzo es inferior a la de la pared.',
  MAXIMUM_WALL_HEIGHT_KEY: 'La altura máxima de la pared es de {0} {1}.',
  FINISHING_KEY: 'Acabado',
  MIRROR_KEY: 'Espejo',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'Filas',
  COLUMNS_KEY: 'Columnas',
  DEFAULT_WALL_SIZE_KEY: 'Tamaño de la pared predeterminado',
  EDIT_KEY: 'Editar',
  TOP_KEY: 'Arriba',
  BOTTOM_KEY: 'Parte inferior'
};
